import React, { useState } from 'react';
import { useNaviagte, useNavigate } from 'react-router-dom';
import SecureLS from 'secure-ls';
import AuthService from './auth/AuthServices'
import './AuthPage.css'

const AuthPage = () => {
    const [loginErrorMessage, setLoginErrorMessage] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const ls = new SecureLS({encodingType: 'aes'})

    const handleLogin = () => {
        const payload = {
            login: userEmail,
            password: password,
            admin: "true"
        }
        const Respose = AuthService.login(payload)
            .then(async (res) => {
                if (res.status === 200 || res.status === 201) {
                    let {
                        user,
                        token
                    } = await res.json();
                    ls.set('jwtToken', token.access_token);
                    navigate('/home')
                } else {
                    console.log(res)
                    setLoginErrorMessage("Falche Email oder Password")
                }

            })
    };

    return (
        <div className={'main-container'}>
            <div className={'title-container'}>
                <div>Autonomio - Admin Portal</div>
            </div>
            <br />

            <div className={'input-container'}>
                <input
                value={userEmail}
                placeholder="E-Mail hier eingeben"
                onChange={(ev) => setUserEmail(ev.target.value)}
                className={'input-box'}
                />
            </div>
            <br />
            <div className={'input-container'}>
                <input
                value={password}
                type='password'
                placeholder="Passwort hier eingeben"
                onChange={(ev) => setPassword(ev.target.value)}
                className={'input-box'}
                />
            </div>
            <br />
            <div className="error-label">{loginErrorMessage}</div>
            <div className={'input-container'}>
                <input className={'input-button'} type="button" onClick={handleLogin} value={'Anmelden'} />
            </div>
        </div>
        
    )
}

export default AuthPage;